import styled from '@emotion/styled';
import Button from '@shared/components/core/button/CoreButton';
import { ButtonRow } from '@shared/components/core/card/CommonCardStyles';
import { useTranslation } from 'react-i18next';

export interface IProjectsCreateButtonRowProps {
    active: number;
    handleSectionChange: (section: number) => void;
    handleSave?: () => void;
}

export default function ProjectsCreateButtonRow({
    active,
    handleSectionChange,
    handleSave,
}: IProjectsCreateButtonRowProps) {
    const { t } = useTranslation();

    return (
        <StyledButtonRow>
            {active > 1 && (
                <Button $color="simple" $size="small" onClick={() => handleSectionChange(active - 1)}>
                    {t('common:previous')}
                </Button>
            )}
            {handleSave ? (
                <Button onClick={handleSave}>{t('common:save')}</Button>
            ) : (
                <Button $color="secondary" onClick={() => handleSectionChange(active + 1)}>
                    {t('common:next')}
                </Button>
            )}
        </StyledButtonRow>
    );
}

const StyledButtonRow = styled(ButtonRow)`
    justify-content: flex-end;
`;
